import React from 'react';
import PurchaseOrderViewInfoEntry from './PurchaseOrderViewInfoEntry';

import { CustomizedTypography } from '@components/Customized';

import useStyles from './useStyles';
import { CapaQuotationRfqPurchaseOrder } from '@generated/graphql';

/*
 * receiver = partner
 * publish = client
 */
interface PurchaseOrderUserInfoProps {
  currentItem?: CapaQuotationRfqPurchaseOrder;
  userType: 'publish' | 'receiver';
}

const PurchaseOrderUserInfo: React.FC<PurchaseOrderUserInfoProps> = ({
  currentItem,
  userType
}) => {
  const classes = useStyles();

  const userInfo = currentItem?.[userType];
  return (
    <div className={classes.wrapper + ' user-info'}>
      <CustomizedTypography variant="h4" fontWeight="500" gutterBottoms={8}>
        {userType === 'publish' ? '발주처' : '수주처'} 정보
      </CustomizedTypography>

      {userInfo?.companyRegistrationNumber ? (
        <>
          <PurchaseOrderViewInfoEntry
            label="상호"
            data={userInfo?.organizationName}
          />
          <PurchaseOrderViewInfoEntry
            label="등록번호"
            data={userInfo?.companyRegistrationNumber}
          />
        </>
      ) : (
        <PurchaseOrderViewInfoEntry
          label="담당자명"
          data={userInfo?.managerName}
        />
      )}
    </div>
  );
};

export default PurchaseOrderUserInfo;
